/**
 * BULGU-019: route guard bileşenleri (PublicRouteGuard, TenantRouteGuard,
 * SuperAdminLayout) önceden yalnızca localStorage'da ilgili token anahtarının
 * VAR OLUP OLMADIĞINA bakıyordu — süresi dolmuş ya da bozuk bir token bile
 * "geçerli oturum" sayılıyordu ve token içindeki `role` claim'i hiç
 * doğrulanmıyordu. Bu modül, bir token'ın hem süresinin dolmadığını hem de
 * beklenen role sahip olduğunu doğrulayan paylaşılan bir yardımcıdır.
 */
import { jwtDecode } from "jwt-decode";
import { hasSessionForRoles } from "./authSession";

/**
 * `token`'ı decode eder ve payload'ını döner; token yoksa, bozuksa ya da
 * süresi dolmuşsa (`exp` claim'i geçmişte kalmışsa) null döner.
 */
export function getValidTokenPayload(token) {
  if (!token || typeof token !== "string") return null;

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    return null;
  }

  if (!decoded || typeof decoded !== "object") return null;

  if (typeof decoded.exp === "number" && decoded.exp * 1000 <= Date.now()) {
    return null;
  }

  return decoded;
}

/**
 * `token`, süresi dolmamış ve `role` claim'i `allowedRoles` içinde olan
 * geçerli bir JWT'ye çözümleniyorsa true döner.
 */
export function isTokenValidForRoles(token, allowedRoles) {
  const payload = getValidTokenPayload(token);
  if (!payload) return false;
  return Array.isArray(allowedRoles) && allowedRoles.includes(payload.role);
}

/** BULGU-016: JWT localStorage kullanılmıyorsa oturum metadata ile doğrula. */
export function isSessionValidForRoles(allowedRoles) {
  return hasSessionForRoles(allowedRoles);
}
